export default __webpack_public_path__ + "static/media/noElementsFound.0e23dc73.png";